import { render } from "./SpinningCircle.vue?vue&type=template&id=af6a1242&lang=pug"
import script from "./SpinningCircle.vue?vue&type=script&lang=js"
export * from "./SpinningCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__